import type { StepsProps as AntdStepsProps } from 'antd/lib/steps'
import type { StepProps as AntdStepProps } from 'antd/lib/steps'
import classNames from 'classnames'
import React, { ReactNode } from 'react'

import { ConfigConsumer } from 'antd/lib/config-provider'
import { default as AntdSteps } from 'antd/lib/steps'

export * from 'antd/lib/steps'

export interface StepsProps extends AntdStepsProps {
  children?: Array<React.ReactElement>
}

export function Steps({ className, type, children, ...rest }: StepsProps) {
  let navContainDesc: boolean = false
  if (children) {
    if (Array.isArray(children)) {
      navContainDesc = children.some((child) => {
        if (child && child instanceof Object && child.props && child.props instanceof Object) {
          return child.props.description
        }
      })
    }
  }
  return (
    <ConfigConsumer>
      {({ getPrefixCls }) => {
        const prefixCls = getPrefixCls('steps')
        return (
          <AntdSteps
            className={classNames(
              prefixCls,
              {
                [`${prefixCls}-tntd-navigation`]: type === 'navigation',
                [`${prefixCls}-tntd-navigation-contain-desc`]:
                  type === 'navigation' && navContainDesc,
              },
              className
            )}
            type={type}
            children={children}
            {...rest}
          />
        )
      }}
    </ConfigConsumer>
  )
}

Steps.Step = function ({ description, className, ...rest }: AntdStepProps) {
  return (
    <ConfigConsumer>
      {({ getPrefixCls }) => {
        const prefixCls = getPrefixCls('step')
        return (
          <AntdSteps.Step
            className={classNames(
              prefixCls,
              {
                [`${prefixCls}-tntd-navigation-desc`]: !!description,
              },
              className
            )}
            description={description}
            {...rest}
          />
        )
      }}
    </ConfigConsumer>
  )
}
